/*
 * @File index.js
 * @Description This File is for vendors store module
 */
import state from '@/store/modules/vendors/state'
import mutations from '@/store/modules/vendors/mutations'
import actions from '@/store/modules/vendors/actions'
import getters from '@/store/modules/vendors/getters'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
